module.exports = __webpack_public_path__ + "img/mark-gray.a28e1bc9.svg";